// Use compiled index.esm.js
module.exports = require('./dist/index.esm.js')
